import React, { FunctionComponent, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { ErrorBoundary } from 'app/components/error-boundary';
import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { clearPendingOrderRequestsActionCreator } from 'app/pages/order/redux/action-creators/clear-pending-order-requests-action-creator';
import { StyledApp, StyledContent } from 'app/app.styled';
import { Header } from 'app/components/header';
import { Footer } from 'app/components/footer';

import '@altibox/design-system-component-lib/dist/index.css';

export const App: FunctionComponent = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(clearPendingOrderRequestsActionCreator());
    }, [dispatch]);

    return (
        <StyledApp>
            <Header />
            <StyledContent>
                <ErrorBoundary>
                    <Outlet />
                </ErrorBoundary>
            </StyledContent>
            <Footer />
        </StyledApp>
    );
};
